import { IResource } from "../i18n";

// tslint:disable-next-line: variable-name
const translation_fr: IResource = {
    feedback_button_text: "Send",
    feedback_cta_0_3: "Nous sommes vraiment désolés, dites-nous ce que nous devons corriger",
    feedback_cta_4_6: "C'est une déception, allez-vous nous dire quoi améliorer ?",
    feedback_cta_7_8: "Que pouvons-nous faire pour l'améliorer ?",
    feedback_cta_9_10: "Fantastique ! Pouvez-vous nous dire une chose que vous avez le plus appréciée ?",
    feedback_mail_subject: "Répondre aux commentaires des applicationsk",
    feedback_text_legend: "Nous sommes également reconnaissants des commentaires négatifs et positifs",
    feedback_text_title: "Donnez votre avis ici (facultatif)",
    feedback_title_finished: "Votre rencontre est terminée",
    feedback_title_ongoing: "S'il vous plaît nous aider à améliorer Meet",
    feedback_title_question: "Quelle est la probabilité que vous recommandiez Meet à un ami ou un collègue ?",
    feedback_value_best: "Très probable",
    feedback_value_worst: "Pas du tout",

    onboarding_button_jointext: "Rejoignez Meet",
    onboarding_description_four: "bouton.",
    onboarding_description_one: "En tant que nouvel utilisateur, vous pouvez personnaliser la façon dont les autres vous verront lors de cette rencontre.",
    onboarding_description_three: "REJOIGNEZ-NOUS",
    onboarding_description_two: "Une fois prêt, cliquez simplement ",
    onboarding_label_color: "Couleur",
    onboarding_label_consentAgree: "Je suis d'accord avec Meet",
    onboarding_label_consentAnd: "et",
    onboarding_label_consentPrivacy: "Politique de confidentialité",
    onboarding_label_consentTermsOfUse: "Conditions d'utilisation",
    onboarding_label_darkTheme: "Thème sombre",
    onboarding_label_firstName: "Votre nom (facultatif)",
    onboarding_label_green: "Vert",
    onboarding_label_indigo: "Indigo",
    onboarding_label_lastName: "Votre nom (facultatif)",
    onboarding_label_lightTheme: "Thème clair",
    onboarding_label_orange: "Orange",
    onboarding_label_pink: "Rose",
    onboarding_label_purple: "Violet",
    onboarding_label_teal: "Sarcelle",
    onboarding_label_theme: "Thème",
    onboarding_label_yellow: "Jaune",
    onboarding_title: "Ravi de vous rencontrer !",

    invite_legend_text: "Envoyez ce lien à une personne que vous souhaitez appeler",
    invite_link_copy: "Copier le lien",
    invite_link_defaultCopied: "Lien copié dans le presse-papiers !",
    invite_link_email: "Invitation par e-mail",
    invite_link_label: "URL de votre invitation",
    invite_link_sms: "Invitation par SMS",
    invite_mail_body: "Salut, rejoignez-moi lors de ma rencontre",
    invite_mail_signature: "Cordialement",
    invite_mail_subject: "Votre lien pour Meet",
    invite_title_text: "INVITEZ QUELQU'UN À VOTRE RÉUNION",

    citypicker_label: "Ville",
    citypicker_nomatch: "Aucun emplacement correspondant",

    userprofile_city_label: "Ville",
    userprofile_color_label: "Couleur",
    userprofile_email_label: "Adresse électronique",
    userprofile_label_green: "Vert",
    userprofile_label_indigo: "Indigo",
    userprofile_label_orange: "Orange",
    userprofile_label_pink: "Rose",
    userprofile_label_purple: "Violet",
    userprofile_label_teal: "Sarcelle",
    userprofile_label_yellow: "Jaune",
    userprofile_locale_label: "Langue",
    userprofile_name_label: "Prénom",
    userprofile_surname_label: "Nom de famille",
    userprofile_theme_label: "Thème",
    userprofile_themedark_label: "Thème sombre",
    userprofile_themelight_label: "Thème clair",

    options_tab_profile: "Profil",

    consentdialog_button_cancel: "Annuler",
    consentdialog_button_ok: "D'accord",

    layout_meet_end: "Fin de la rencontre",
    layout_meet_leave: "Quitter Meet",

    layout_sidebar_labelClose: "Fermer le menu de la barre latérale",
    layout_sidebar_labelOpen: "Ouvrir le menu de la barre latérale",
    layout_sidebar_labelTitle: "Ouvrir le menu de la barre latérale",
    layout_title_text: "Meet | Entrevues sans friction",

    layout_toolbar_enter: "Passer en mode plein écran",
    layout_toolbar_invite: "Inviter",
    layout_toolbar_invite_tooltip: "Invitez d'autres personnes à cette rencontre",
    layout_toolbar_leave: "Laisser en plein écran",

    layout_dialog_descriptionEnd: "Cela mettra fin à Meet pour tous les participants",
    layout_dialog_titleEnd: "Voulez-vous vraiment mettre fin à cette rencontre ?",
    layout_dialog_titleLeave: "Voulez-vous vraiment quitter cette rencontre ?",

    layout_dialog_descriptionLeave: "Cela ne mettra PAS fin à Meet pour les autres participants",
    layout_sidebar_explorer: "Aide",
    layout_sidebar_feedback: "Partagez vos commentaires",
    layout_sidebar_settings: "Réglages",

    layout_finish_endmeet: "Mettre fin à la réunion en cours",
    layout_finish_leavemeet: "Quitter la réunion en cours",

    layout_cta_register: "Besoin d'une rencontre gratuite de 60 minutes ?",
    layout_cta_register_tooltip: "Inscrivez-vous pour un crédit de 10 $ gratuit",

    layout_dialog_descriptionAbandon: "On dirait que tu es le seul à appeler",
    layout_dialog_titleAbandon: "Souhaitez-vous terminer cette rencontre ?",

    language_en_title: "English",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_de_title: "Deutsche",
    language_fr_title: "Français",
    language_es_title: "Español",
    language_it_title: "Italian",
    language_pl_title: "Polski",

    meeting_finished_title: "RÉUNION TERMINÉE",
    meeting_finished_tooltip: "Accès à la lecture seulement",

    layout_reactivate_button: "Réactiver Meet",
    layout_reactivate_tooltip: "Cliquez ici si vous souhaitez rouvrir et utiliser cette rencontre terminée",
    layout_dialog_titleReactivate: "Voulez-vous vraiment réactiver cette rencontre?",
    layout_dialog_descriptionReactivate: "Cela rouvrira le Meet pour rejoindre, éditer et autres modifications",

    toast_reconnecting_title: "Problème de signalisation d'appel",
    toast_reconnecting_message: "Connexion (état: {state}) perdue en raison de l'erreur {error}. Reconnexion ...",
    toast_reconnected_title: "Signalisation d'appel",
    toast_reconnected_message: "Connexion rétablie. État: {state}",
    toast_disconnected_title: "Erreur de signalisation d'appel",
    toast_disconnected_message: "Connexion (état: {state}) fermée en raison de l'erreur {error}." +
                                 "Essayez d'actualiser cette page pour redémarrer la connexion.",

    config_title_text: "Créer une nouvelle rencontre",
    config_title_ctaOne: "Veuillez définir les éléments d'un nouveau Meet que vous souhaitez créer.",
    config_title_ctaTwo: "Toutes les données d'entrée sont facultatives et peuvent être omises.",
    config_title_label: "Titre",
    config_description_label: "Description",
    config_duration_label: "Durée",
    config_tool_label: "Outils de rencontre",
    config_tool_call: "Répondre à l'appel vidéo",
    config_tool_editor: "Editeur de code",
    config_tool_whiteboard: "Tableau blanc",
    config_passcode_label: "Rencontrer le mot de passe (le cas échéant)",

    search_placeholder_text: "Entrez les critères de recherche",
    createMeeting_button_create: "Créer une rencontre",

    projectboard_scheduleinfo_none: "La réunion n'a pas de date de début définie, elle peut donc être utilisée à tout moment",
    projectboard_scheduleinfo_anytime: "à tout moment",

    projectboard_join_anyone: "Toute personne disposant d'un lien peut rejoindre",
    projectboard_role_guest: "Client",
    projectboard_role_interviewee: "Candidat",
    projectboard_role_interviewer: "Interviewer",
    projectboard_role_organizer: "Organisateur",

    projectboard_status_draft: "En projet",
    projectboard_status_scheduling: "Planification",
    projectboard_status_schedulingFailed: "Échec de la planification",
    projectboard_status_pending: "En attente",
    projectboard_status_ready: "Prêt",
    projectboard_status_starting: "Départ",
    projectboard_status_inprogress: "En cours",
    projectboard_status_onhold: "En attente",
    projectboard_status_completed: "Terminé",
    projectboard_status_canceled: "Annulé",
    projectboard_status_archived: "Archivé",
    projectboard_status_feedbackWait: "En attente de commentaires",
    projectboard_status_feedbackDone: "Rétroaction recueillie",
    projectboard_status_feedbackFail: "Échec de la collecte des commentaires",

    projectboard_status_stopped: "Arrêté",

    minibar_dashboard_title: "Bord",
    
    layout_sidebar_rateus: "Évaluez-nous",
    
    invite_passcode_label: "Code",

    invite_text_copy: "Copier l’invitation",

    invite_text_body: "S’il vous plaît rejoindre ma rencontre à {url}",
    
    invite_passcode_body: "S’il vous plaît rejoindre mon Meet à {url} et utiliser le code d’accès {passcode}",

    invite_text_copied: "Le texte de l’invitation meet est copié dans le presse-papiers.",

    invite_pascode_add: "Ajouter un code d’accès à l’URL",
    
    participant_join_message : "{participant} avait rejoint la réunion.",
    participant_left_message : "{participant} avait quitté la réunion.",
    
    minibar_dashboard_tooltip: "Gérez vos entrevues",
    
    layout_sidebar_snapshot: "Instantané",

    snapshots_none_text: "Prenez un ou plusieurs instantanés de l’éditeur de code et du tableau blanc et passez-les en revue après la rencontre.",
    snapshot_toast_text: "Snapshot taken",
    snapshots_cta_text: "Prendre un instantané (F9)",
    snapshot_sentiment_positive: "Instantané positif",
    snapshot_sentiment_negative: "Instantané négatif",
    snapshot_sentiment_note: "Note",
    
    snapshot_personal_value: "Instantané personnel",
    snapshot_personal_title: "Visible uniquement pour vous",
    snapshot_team_value: "Instantané de l’équipe",
    snapshot_team_title: "Visible uniquement à votre équipe.",
    snapshot_public_title: "Visible pour tous les participants",
    snapshot_public_value: "Instantané public",

    snapshots_live_text: "Revenir à l’interview en direct",
    
    snapshot_action_delete: "Supprimer",
    snapshot_action_load: "Instantané de charge",
    
    snapshot_delete_dialog_title: "Supprimer l’instantané?",
    snapshot_delete_dialog_description: "S’il vous plaît confirmer que vous voulez supprimer cet instantané",
    snapshots_final_back: "Revenir à Meet end state",
    

};

export default translation_fr;
